export default ({ request }) => ({
  ecomOrderListApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/order/list',
      method: 'POST',
      data,
    })
  },
  ecomOrderDetailApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/order/detail',
      method: 'POST',
      data,
    })
  },
  ecomOrderSendEmailApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/order/sendEmail',
      method: 'POST',
      data,
    })
  },
  ecomOrderConfirmApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/order/confirm',
      method: 'POST',
      data,
    })
  },
})
